'use client'

import clsx from 'clsx'
import Image from 'next/image'
import { useRouter } from 'next/navigation'

import { isNotNilOrEmpty } from 'shared/utils/ramda'
import { addTestId } from 'shared/utils/tests'

import { ProductBadgeProps } from '../../types/products'

import styles from './Badge.module.scss'

interface BadgeProps {
  badge: ProductBadgeProps
  isExpanded?: boolean
  rootCategorySlug?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const Badge = ({
  badge,
  isExpanded,
  rootCategorySlug,
  onMouseEnter,
  onMouseLeave
}: BadgeProps) => {
  const router = useRouter()

  const { name, imagePath, size, id, isBio } = badge
  const redirectToFilterByTag = async () => {
    if (rootCategorySlug) {
      void router.push(`${rootCategorySlug}?filter[tag][0]=${id}`)
    }
  }

  return (
    (size === 'full' || isNotNilOrEmpty(imagePath)) && (
      <div
        className={clsx(styles.root, {
          [styles.notClickable]: !isNotNilOrEmpty(rootCategorySlug)
        })}
        tabIndex={isNotNilOrEmpty(rootCategorySlug) ? 0 : -1}
        role={isNotNilOrEmpty(rootCategorySlug) ? 'button' : undefined}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-size={isExpanded ? 'full' : size}
        data-bio={isBio}
        onClick={redirectToFilterByTag}
      >
        {isNotNilOrEmpty(imagePath) && (
          <div className={styles.icon} data-size={size} data-bio={isBio}>
            <Image
              fill
              src={imagePath}
              alt='app-badges'
              {...addTestId('product-tag-badge')}
            />
          </div>
        )}
        {!isBio && (size !== 'mini' || isExpanded) && <span>{name}</span>}
      </div>
    )
  )
}

export default Badge
